import { render, staticRenderFns } from "./ProjectDirectory.vue?vue&type=template&id=04776425&style=display%3A%20flex"
import script from "./ProjectDirectory.vue?vue&type=script&lang=js"
export * from "./ProjectDirectory.vue?vue&type=script&lang=js"
import style0 from "./ProjectDirectory.vue?vue&type=style&index=0&id=04776425&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports